"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customErrorMap = void 0;
const zod_1 = require("zod");
const capitalize = (str) => str.replace(/^\S/g, (t) => t.toUpperCase());
const customErrorMap = (issue, ctx) => {
    if (issue.code === zod_1.z.ZodIssueCode.invalid_enum_value) {
        const code = capitalize(issue.code.replace(/_/g, ' '));
        const received = `received: ${ctx.data}`;
        const expected = `Expected ${issue.options.join(' | ')}`;
        return { message: `${code}, ${received}. ${expected}` };
    }
    return { message: ctx.defaultError };
};
exports.customErrorMap = customErrorMap;
